// extracted by mini-css-extract-plugin
export default {"container":"HomeView__container___SCWdy","contents":"HomeView__contents___byTIa","title":"HomeView__title____huSx","logo":"HomeView__logo___yZNLi"};